import { get } from '../utils'

export const health = () => {
  return get('/health')
}
export const healthApi = {
  health

}
